<script setup lang="ts">
import { ref, computed } from "vue"
import ModalTripExpired from '~/components/ui/modal-trip-expired/ModalTripExpired.vue'
import PopupCommon from '~/components/ui/popup/PopupCommon.vue'
import { useTripPlanStore } from '~/store/pinia/tripPlan'

const tripPlanStore = useTripPlanStore()

const dataTrip = computed(() => tripPlanStore.dataTrip)

const modalExpiredTitle = ref('Trip Plan Expired')
const modalExpiredActive = ref(false)
const dataExpired = ref({})
const designerExpired = ref('')
const expertIDExpired = ref(0)
const tripIDExpired = ref(0)
const messageExpired = ref('')

function closeExpiredModal() {
  modalExpiredActive.value = false
}
function chatValidateOpen() {
  modalExpiredActive.value = false
}
function emitBook(message: any) {
  if (message.message_alert) {
    designerExpired.value = message.message_alert.expert_first_name
    expertIDExpired.value = parseInt(message.message_alert.expert_id)
    modalExpiredTitle.value = message.message_alert.title
    messageExpired.value = message.message_alert.message
  }
  dataExpired.value = message
  tripIDExpired.value = dataTrip.value.enquiry_id
  modalExpiredActive.value = !modalExpiredActive.value
}
function togglePopupExpired() {
  designerExpired.value = dataTrip.value.designer.first_name
  expertIDExpired.value = parseInt(dataTrip.value.designer.id)
  tripIDExpired.value = dataTrip.value.enquiry_id
  modalExpiredActive.value = !modalExpiredActive.value
}
defineExpose({
  emitBook,
  togglePopupExpired,
  closeExpiredModal,
})
</script>

<template>
  <PopupCommon :modalTitle="modalExpiredTitle" :modalActive="modalExpiredActive" @update:close="closeExpiredModal">
    <template #content>
      <ModalTripExpired
        :dataExpired="dataExpired"
        :designer="designerExpired"
        :expertID="expertIDExpired"
        :tripID="tripIDExpired"
        :message="messageExpired"
        @handleExpiredModal="chatValidateOpen"
      />
    </template>
  </PopupCommon>
</template>

<style lang="scss" scoped></style>
